/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Error_Max_RoundsInputs */



/**
* | output |
* | --- |
* | "Max rounds must be 2, 3, or 4" |
*
* @param {Tournament_New_Error_Max_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_error_max_rounds = /** @type {((inputs?: Tournament_New_Error_Max_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Error_Max_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nombre maximum de rondes doit être 2, 3 ou 4")
	if (locale === "es") return /** @type {LocalizedString} */ ("El número máximo de rondas debe ser 2, 3 o 4")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O número máximo de rodadas deve ser 2, 3 ou 4")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il numero massimo di round deve essere 2, 3 o 4")
	return /** @type {LocalizedString} */ ("Max rounds must be 2, 3, or 4")
});